document.addEventListener("DOMContentLoaded", function () {
  if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick !== "undefined") {
    jQuery('.m-contact-form__info').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      speed: 500,
      fade: false,
      cssEase: 'linear',
      prevArrow: `<button type="button" class="slick-prev custom-prev" aria-label="Previous">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
      </button>`,
      nextArrow: `<button type="button" class="slick-next custom-next" aria-label="Next">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
      </button>`,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 1, fade: true } }
      ]
    });
  }
});
